/**
 * 幸运礼物动效展示
 */
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { UiModal } from 'components';
import svga from '../animation/svga';
import { observer } from 'mobx-react';
import { useStateful, useNumber, useBoolean } from 'react-hanger';
import { hooks, hoc } from 'lib';

let { withPopup } = hoc;
let awardItems = [
  // {
  //   gift_pic: 'https://img-photo.sumeme.com/photo/94924701/1608140979346/3318.jpg',
  //   gift_name: '撒打算的',
  //   multiple: 1,
  //   prize: 100
  // },
  // {
  //   gift_pic: 'https://img-photo.sumeme.com/photo/94924701/1608140979346/3318.jpg',
  //   gift_name: '撒打算的',
  //   multiple: 0.5,
  //   prize: 100
  // }
];

export const LuckAward = withPopup(
  observer((props) => {
    const { onClose } = props;
    const count = useNumber(0);
    const isClose = useBoolean(false);
    const activeItem = useStateful({});

    const { multiple, prize } = activeItem.value;

    useEffect(() => {
      svga.play({
        url: 'https://img.sumeme.com/40/0/1611913675624.svga',
        domId: 'multi-lucky-animation',
        loops: 0,
      });
    }, []);

    useEffect(() => {
      if (!awardItems.length) {
        isClose.setTrue();
        onClose();
        return;
      }
      const item = awardItems.pop();
      activeItem.setValue(item);
    }, [count.value]);

    hooks.useInterval(
      () => {
        count.decrease();
      },
      !isClose.value ? 3000 : null,
    );

    const getNumPic = (num = 0) => {
      let numFormat = Number(Number(num).toFixed(1)) || 0;
      let numStr = `${numFormat}`;
      let strArr = numStr.split('');
      return strArr.map((str) => {
        if (str === '.') {
          return <i className={`num-pic num-pic-dian`} />;
        }
        return <i className={`num-pic num-pic-${str}`} />;
      });
    };

    return (
      <UiModal
        className="modal-blank"
        maskCloseEnable={false}
        isShowFooter={false}
        {...props}
      >
        <Wrap id="multi-lucky-animation">
          <div className="lucky-info">
            <div className="luck-title"></div>
            {multiple < 1 ? (
              <div className="multiple">
                {getNumPic(prize)}
                <span>柠檬</span>
              </div>
            ) : (
              <div className="luck-times">
                <p className="multiple">
                  {getNumPic(multiple)}
                  <span>倍</span>
                </p>
                <p className="gradient-text">总价值{prize}柠檬</p>
              </div>
            )}
          </div>
        </Wrap>
      </UiModal>
    );
  }),
);

export const pushAwardItems = (items) => {
  if (awardItems.length === 0) {
    awardItems = awardItems.concat(items);
    LuckAward.show();
    return;
  }
  awardItems = awardItems.concat(items);
};

const Wrap = styled.div`
  position: relative;
  text-align: center;
  width: 375px;
  height: 667px;
  .lucky-info {
    position: absolute;
    z-index: 12;
    left: 0;
    right: 0;
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding-top: 158px;
  }
  .luck-title {
    width: 224px;
    height: 58px;
    margin: 0 auto 10px;
    background: url(${require('./images/title.png')}) center/contain no-repeat;
  }
  .multiple {
    width: 100%;
    height: 50px;
    text-align: center;
    i {
      display: inline-block;
      vertical-align: bottom;
      width: 34px;
      height: 50px;
    }
    span {
      display: inline-block;
      vertical-align: bottom;
      font-size: var(--fs-mdx);
      height: 20px;
      line-height: 20px;
      color: #fbfb00;
    }
  }
  .gradient-text {
    color: #fffaf1;
    background-image: linear-gradient(
      180deg,
      #ffffff 30%,
      #ffe8ae 50%,
      #ffd261 80%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: var(--fs-lg);
    height: 24px;
    line-height: 24px;
    text-align: center;
    margin-top: 10px;
  }
  .num-pic-0 {
    background: url(${require('./images/num-0.png')}) center/contain no-repeat;
  }
  .num-pic-1 {
    background: url(${require('./images/num-1.png')}) center/contain no-repeat;
  }
  .num-pic-2 {
    background: url(${require('./images/num-2.png')}) center/contain no-repeat;
  }
  .num-pic-3 {
    background: url(${require('./images/num-3.png')}) center/contain no-repeat;
  }
  .num-pic-4 {
    background: url(${require('./images/num-4.png')}) center/contain no-repeat;
  }
  .num-pic-5 {
    background: url(${require('./images/num-5.png')}) center/contain no-repeat;
  }
  .num-pic-6 {
    background: url(${require('./images/num-6.png')}) center/contain no-repeat;
  }
  .num-pic-7 {
    background: url(${require('./images/num-7.png')}) center/contain no-repeat;
  }
  .num-pic-8 {
    background: url(${require('./images/num-8.png')}) center/contain no-repeat;
  }
  .num-pic-9 {
    background: url(${require('./images/num-9.png')}) center/contain no-repeat;
  }
  .num-pic-dian {
    background: url(${require('./images/num-dian.png')}) center/contain
      no-repeat;
    margin-left: -8px;
    margin-right: -8px;
  }
`;
